import {display_pair, display_singleton, edit_pair, edit_singleton} from "./constants";
import InfoModal from "./../modals/buttons/InfoModal"

interface EditableEntryProps {
    isEditing?: boolean;
    label?: string;
    editingChildren?: React.ReactNode;
    viewingChildren?: React.ReactNode | string;
    id?: string;
    singleLine?: boolean;
    reverseLabelChildOrder?: boolean;
    explanation?: string | Element;
}

const EditableEntry = ({isEditing = false, label = "", editingChildren, viewingChildren, id = null, singleLine = false, reverseLabelChildOrder = false, explanation}: EditableEntryProps) => {
    let cn: string;

    if (isEditing)
        if (label)
            cn = edit_pair;
        else
            cn = edit_singleton;
    else
        if (label)
            cn = display_pair;
        else
            cn = display_singleton;

    const infoModal = explanation ? <InfoModal modalTitle={`Explanation of ${label}`} buttonToolTip={`Explanation of ${label}`}>{explanation}</InfoModal> : null;

    const labelV =
        label ?
            isEditing ?
            <><label htmlFor={id} style={{fontWeight: reverseLabelChildOrder ? 500 : undefined}}>{label}{infoModal}</label></> :
            <><span>{label}{infoModal}</span></> :
        null;

    const valueV =
        isEditing ?
            editingChildren :
            (typeof viewingChildren === "string" ?
                <span>{viewingChildren}</span> :
                viewingChildren);

    let vals = [labelV, valueV];

    if (reverseLabelChildOrder)
        vals.reverse();

    return <div className={cn} style={singleLine ? {
        display: "flex",
        alignItems: "center",
    } : null}>
        {vals}
    </div>
}

export default EditableEntry;
